import React, { Component } from 'react';
import { Header, Table, List } from 'semantic-ui-react';

import presOrder from '../data/pres-order';

export default class TermPaperPresentationOrderPage extends Component {
  render() {
    const getStudentsForTopic = (topic) => {
      return presOrder.filter(obj => obj["topic"] === topic);
    }

    const convertStudentsToRows = (students) => {
      return students.map((student) => {
        return (
          <Table.Row>
            <Table.Cell>{ student.student }</Table.Cell>
            <Table.Cell>{ student.rand }</Table.Cell>
          </Table.Row>
        )
      })
    }

    const students = convertStudentsToRows(presOrder)

    return (
      <div>
        <Header as='h1' content='Term Paper Presentation Order'/>
        <Table definition>
          <Table.Header>
            <Table.HeaderCell>Student</Table.HeaderCell>
            <Table.HeaderCell>Rand</Table.HeaderCell>
          </Table.Header>
          <Table.Body>
            { students }
          </Table.Body>
        </Table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/term-paper-presentation-order.js